import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../providers/AuthProvider";
import { useToast } from "../providers/ToastProvider";

export function SessionToastAnnouncer() {
  const { accessToken, isInitializing } = useAuth();
  const toast = useToast();
  const { t } = useTranslation();
  const hasHydratedRef = useRef(false);
  const previousTokenRef = useRef<string | null>(null);

  useEffect(() => {
    if (isInitializing) {
      return;
    }

    if (!hasHydratedRef.current) {
      hasHydratedRef.current = true;
      previousTokenRef.current = accessToken;
      return;
    }

    if (!previousTokenRef.current && accessToken) {
      toast.success(t("auth.login.welcome_back"));
    }

    previousTokenRef.current = accessToken;
  }, [accessToken, isInitializing, t, toast]);

  return null;
}
